<template>
    <div class="page-main">
        <div class="spaceBetween">
            <page-title />
            <div class="spaceRight op-btn">
                <el-button class="refresh-btn" @click="handleRefresh" title="refresh">
                    <i class="el-icon-refresh"></i>
                </el-button>
                <el-button class="primary" @click="handleAddPlan">
                    <img src="@/assets/icons/add.png" style="width: 0.18rem" />
                    <span>Add Plan</span>
                </el-button>
            </div>
        </div>

        <div class="airdrop-header" v-loading="statsLoading">
            <div class="airdrop-title">Airdrop plan</div>
            <div class="airdrop-info">
                <div class="airdrop-status">
                    <span>Airdrop UNIT release status:</span>
                    <div class="progress-container">
                        <div class="progress-bar" :style="{ width: progressPercent + '%' }"></div>
                    </div>
                    <div class="airdrop-numbers">
                        <span>Releasable: {{ releasableAmount }} UNIT</span>
                        <span>Released: {{ releasedAmount }} UNIT</span>
                    </div>
                    <div class="total-amount">Total: {{ totalAmount }} UNIT</div>
                </div>
            </div>
        </div>

        <page-card :noHead="true" class="no-padding">
            <div slot="body" class="page-table" v-loading="loading">
                <div class="table_box">
                    <el-table  :data="tableData">
                        <el-table-column type="index" width="55"></el-table-column>
                        <el-table-column prop="planName" label="Plan name"></el-table-column>
                        <el-table-column prop="claimMethodText" label="Claim Method"></el-table-column>
                        <el-table-column prop="lockedRecordsCount" label="Total address"></el-table-column>
                        <el-table-column prop="planAmount" label="Planned release"></el-table-column>
                        <el-table-column prop="statusText">
                            <template slot="header">
                                <span>Airdrop Status</span>
                                <el-tooltip
                                    content="Displays the current status of this airdrop plan."
                                    placement="top"
                                    effect="dark">
                                    <i class="el-icon-question status-tip-icon"></i>
                                </el-tooltip>
                            </template>
                            <template slot-scope="{row}">
                                <span :class="getStatusClass(row.status)">{{ row.statusText }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Operation" width="180">
                            <template slot-scope="{row}">
                                <span class="text-blue" @click="handleDetails(row)">Details</span>
                                <span  v-if="row.status === 0" class="text-blue" @click="handleDelete(row)">Delete
                                    Plan</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="pagination-container">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="pagination.page" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
                    </el-pagination>
                </div>
            </div>
        </page-card>
        <el-dialog class="msgDio" :visible.sync="detailsDialog" title="Details" width="5rem" center>
            <div>
                <p>Plan ID: {{ currentPlan.planID }}</p>
                <p>Plan Name: {{ currentPlan.planName }}</p>
                <p>Claim Method: {{ currentPlan.claimMethodText }}</p>
                <p>Plan Amount: {{ currentPlan.planAmount }}</p>
                <p>Status: {{ currentPlan.statusText }}</p>
                <p>Locked Records Count: {{ currentPlan.lockedRecordsCount }}</p>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="detailsDialog = false">Close</el-button>
            </div>
        </el-dialog>
        <ErrorMsg ref="ErrorMsg"></ErrorMsg>
        <!-- <metaMaskInit ref="metaMaskInit"></metaMaskInit> -->
    </div>
</template>

<script>
import { getPlans, deletePlan, getAirdropStats } from '@/api/tokenlocker'
import Web3 from 'web3'
import { getAbi } from '@/api/file'
// import metaMaskInit from '@/layout/components/metaMaskInit/index.vue'
export default {
    //   components: {
    //     metaMaskInit
    //   },
    data() {
        return {
            loading: false,
            statsLoading: false,
            tableData: [],
            pagination: {
                page: 1,
                pageSize: 20,
                total: 0
            },
            // Airdrop total amount and progress information
            totalAmount: '0',
            releasableAmount: '0',
            releasedAmount: '0',
            progressPercent: 0, // Percentage value
            detailsDialog: false,
            currentPlan: {},
            contractAddress: '',
            TokenLockerAbi: []
        };
    },
    async mounted() {
        // Get contract information
        await this.getContractInfo();
        // Get airdrop plan list
        this.getList();
        // Get airdrop statistics data from smart contract
        this.getStats();
    },
    methods: {
        // Get contract ABI and address
        async getContractInfo() {
            try {
                const res = await getAbi('TokenLocker')
                if (res.code === 0 && res.data) {
                    this.contractAddress = res.data.address
                    this.TokenLockerAbi = res.data.abi
                } else {
                    this.$refs.ErrorMsg.showErrorMsg('Failed to get contract info')
                }
            } catch (err) {
                console.error('Failed to get contract info', err)
                this.$refs.ErrorMsg.showErrorMsg('Failed to get contract info')
            }
        },
        async getStats() {
            try {
                this.statsLoading = true;
                
                // Ensure contract information is obtained
                if (!this.contractAddress || !this.TokenLockerAbi.length) {
                    console.error('Contract information not obtained, unable to get statistics data')
                    this.statsLoading = false;
                    return
                }
                
                // Initialize Web3, preferring MetaMask, if not available use public node
                let web3;
                if (window.ethereum) {
                    web3 = new Web3(window.ethereum);
                    // Check if MetaMask is connected
                    try {
                        // Silently check accounts, don't pop up MetaMask
                        const accounts = await web3.eth.getAccounts();
                        if (accounts.length === 0) {
                            console.log('MetaMask not connected, using public node');
                            web3 = new Web3("https://ethereum-sepolia-rpc.publicnode.com");
                        }
                    } catch (error) {
                        console.log('Failed to check wallet connection, using public node', error);
                        web3 = new Web3("https://ethereum-sepolia-rpc.publicnode.com");
                    }
                } else {
                    // No MetaMask, use public node
                    console.log('MetaMask not detected, using public node');
                    web3 = new Web3("https://ethereum-sepolia-rpc.publicnode.com");
                }
                
                // Create contract instance
                const contract = new web3.eth.Contract(this.TokenLockerAbi, this.contractAddress);
                
                // Call contract function to get total locked amount and available amount
                const [totalLockedAmount, availableAmount] = await Promise.all([
                    contract.methods.getTotalLockedAmount().call(),
                    contract.methods.getTotalAvailableAmount().call()
                ]);
                console.log('totalLockedAmount',totalLockedAmount);
                console.log('availableAmount',availableAmount);
                // Convert returned Wei to UNIT and format number
                const totalInUnit = web3.utils.fromWei(totalLockedAmount, 'ether');
                const availableInUnit = web3.utils.fromWei(availableAmount, 'ether');
                console.log('totalInUnit',totalInUnit);
                console.log('availableInUnit',availableInUnit);
                // Calculate allocated amount (total amount minus available amount)
                const allocatedInUnit = Number(totalInUnit) - Number(availableInUnit);
                console.log('allocatedInUnit',allocatedInUnit);
                // Update data
                this.totalAmount = this.formatNumber(totalInUnit);
                this.releasableAmount = this.formatNumber(availableInUnit);
                this.releasedAmount = this.formatNumber(allocatedInUnit > 0 ? allocatedInUnit : 0);
                
                // Calculate progress percentage
                if (Number(totalInUnit) > 0) {
                    this.progressPercent = (availableInUnit / Number(totalInUnit)) * 100;
                    // Ensure percentage is not negative and does not exceed 100
                    this.progressPercent = Math.max(0, Math.min(100, this.progressPercent));
                }
                console.log('this.progressPercent',this.progressPercent);
                
                this.statsLoading = false;
            } catch (err) {
                console.error('Failed to get contract data:', err);
                this.statsLoading = false;
                
                // Use default values
                // this.totalAmount = '90,000,000';
                // this.releasableAmount = '80,000,000';
                // this.releasedAmount = '10,000,000';
                // this.progressPercent = 11;
                
                // Display error message
                this.$refs.ErrorMsg.showErrorMsg('Failed to get airdrop statistics data');
            }
        },
        // Helper function to format number
        formatNumber(num) {
            return Number(num).toLocaleString();
        },
        async getList() {
            try {
                this.loading = true;
                const res = await getPlans({
                    page: this.pagination.page,
                    pageSize: this.pagination.pageSize
                });
                console.log('getListres',res);
                if (res.code === 0 && res.data) {
                    this.tableData = res.data.list.map(item => {
                        // Convert status code to text
                        const statusMap = {
                            0: 'Ready',
                            1: 'In Progress',
                            2: 'Completed',
                            3: 'Deleted'
                        };

                        // Convert claim method to text
                        const claimMethodMap = {
                            0: 'Direct',
                            1: 'Self claim'
                        };

                        return {
                            ...item,
                            statusText: statusMap[item.status] || 'Unknown',
                            claimMethodText: claimMethodMap[item.claimMethod] || 'Unknown'
                        };
                    });

                    this.pagination.total = res.data.total || 0;
                    this.pagination.page = res.data.page || 1;
                    this.pagination.pageSize = res.data.pageSize || 20;
                } else {
                    this.$message.error('Failed to get data');
                }
                this.loading = false;
            } catch (err) {
                console.log(err);
                this.loading = false
                this.$message.error('Failed to get data');
            }
        },
        handleSizeChange(size) {
            this.pagination.pageSize = size;
            this.getList();
        },
        handleCurrentChange(page) {
            this.pagination.page = page;
            this.getList();
        },
        handleAddPlan() {
            this.$router.push({
                path: "/airdropPlan/add"
            });
        },
        handleDetails(row) {
            this.$router.push({
                path: `/airdropPlan/detail/${row.planID}`
            });
        },
        async handleDelete(row) {
            try {
                await this.$confirm('Once this plan is deleted, it will no longer be executed. You will need to create a new plan to complete the airdrop. This action cannot be undone.', 'Delete Airdrop Plan?', {
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                });
                this.loading = true;
                const res = await deletePlan({
                    planID: row.planID
                });

                if (res.code === 0) {
                    this.$message.success('Delete successfully');
                    this.getList();
                } else {
                    this.$message.error(res.msg || 'Delete failed');
                }
                this.loading = false;
            } catch (err) {
                if (err !== 'cancel') {
                    console.error(err);
                    this.$message.error('Operation failed');
                }
            }
        },
        getStatusClass(status) {
            // 0: 'Ready',
            // 1: 'In Progress',
            // 2: 'Completed',
            // 3: 'Deleted'
            const statusClassMap = {
                0: 'status-in-progress',
                1: 'status-ready',
                2: 'status-completed',
                3: 'status-deleted'
            };
            return statusClassMap[status] || '';
        },
        handleRefresh() {
            this.$message({
                message: '正在刷新数据...',
                type: 'info',
                duration: 1000
            });
            this.getList();
            this.getStats();
        }
    }
};
</script>

<style scoped lang="scss">
.airdrop-header {
    background-color: #fff;
    border-radius: 8px;
    padding: 0.24rem 0.32rem;
    margin-bottom: 0.24rem;

    .airdrop-title {
        font-size: 0.24rem;
        font-weight: bold;
        margin-bottom: 0.16rem;
    }

    .airdrop-info {
        display: flex;
        justify-content: space-between;

        .airdrop-status {
            width: 100%;

            .progress-container {
                height: 0.2rem;
                background-color: #f0f0f0;
                border-radius: 10px;
                margin: 0.1rem 0;
                overflow: hidden;

                .progress-bar {
                    height: 100%;
                    background: linear-gradient(264deg, #225bfc 0%, #062567 100%);
                }
            }

            .airdrop-numbers {
                display: flex;
                justify-content: space-between;
                color: #666;
                font-size: 0.14rem;
                margin-bottom: 0.16rem;
            }

            .total-amount {
                text-align: right;
                font-weight: bold;
            }
        }
    }
}

.op-btn {
    margin-bottom: 0.24rem;

    .el-button {
        padding: 0.12rem 0.16rem;
        font-size: 0.18rem;
        line-height: 0.2rem;
        color: #626871;
        border-color: #d9dde3;
        background: #fff;

        &.primary {
            background: linear-gradient(264deg, #225bfc 0%, #062567 100%);
            border-color: transparent;
            color: #fff;
        }
        
        &.refresh-btn {
            margin-right: 0.12rem;
            padding: 0.12rem 0.14rem;
            
            .el-icon-refresh {
                font-size: 0.2rem;
            }
        }
    }
}

.page-table {
    .text-blue {
        color: #225bfc;
        margin-right: 0.12rem;
        cursor: pointer;
    }

    .status-in-progress {
        color: #409EFF;
    }

    .status-ready {
        color: #E6A23C;
    }

    .status-completed {
        color: #67C23A;
    }

    .status-deleted {
        color: #F56C6C;
    }

    .status-tip-icon {
        margin-left: 0.08rem;
        color: #909399;
        font-size: 0.16rem;
        cursor: pointer;
        
        &:hover {
            color: #409EFF;
        }
    }
}

.pagination-container {
    padding: 0.2rem;
    text-align: right;

    .el-pagination {
        bottom: 0;
    }
}

.msgDio {
    /deep/ .el-dialog__header {
        border-bottom: 0;
    }

    div {
        line-height: 30px;
    }
}
</style>
